import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { t } from 'i18next';

import { BaseComponent } from '../../BaseComponent';
import { LayoutType } from '../../../constants/LayoutConstants';
import { ArticleProperties, EAIWSStore } from '../../../stores/EAIWSStore';
import { ArticleItem, ArticleStore } from '../../../stores/ArticleStore';
import { SceneStore } from '../../../stores/SceneStore';
import { UIHelper } from '../../../utils/UIHelper';
import { PropertyEditorActions } from '../../../actions/PropertyEditorActions';
import { SidebarHeader } from '../../SidebarHeader';
import { PropertyClass } from './PropertyClass';
import { ArticleInformations } from './ArticleInformations';
import { ArticlePropertyClass } from './ArticlePropertyClass';

import core = egr.wcf.core;
import eaiws = egr.wcf.eaiws;

type PropertyEditorPropertyClassFilter = (value: core.prop.PropertyClass, index: number, array: Array<core.prop.PropertyClass>) => boolean;

interface PropertyEditorProps {
    visible: boolean;
    layoutType: LayoutType;
    propClassFilter?: PropertyEditorPropertyClassFilter;
    showPrices: boolean;
}

interface PropertyEditorState extends ArticleProperties {
    // articleProperties: eaiws.ArticleProperties;
    selectedBasketIds: Array<string>;
    image: string;
    articleItem: ArticleItem;
    property: core.prop.Property;
    choiceList: Array<core.prop.PropertyValue>;
    selectedElements: number;
}

export class PropertyEditor extends BaseComponent<PropertyEditorProps, PropertyEditorState> {
    public componentWillMount(): void {
        this.addStoreListener(ArticleStore, this.onChange);
        this.addStoreListener(EAIWSStore, this.onChange);
        this.addStoreListener(SceneStore, this.onChange);
        this.onChange();
    }

    public componentDidUpdate(): void {
        UIHelper.updateScrollbar(ReactDOM.findDOMNode(this) as Element);
    }

    public shouldComponentUpdate(nextProps: PropertyEditorProps, nextState: PropertyEditorState): boolean {
        return nextProps.visible || this.props.visible !== nextProps.visible;
    }

    public render(): JSX.Element {
        let cssStyle: React.CSSProperties = {display: 'block'};
        if (this.props.visible) {
            // FixMe: this isn't the right place to trigger actions
            UIHelper.timeout().then(() => {
                PropertyEditorActions.syncEAIWSState();
            });
        }

        if (this.state.properties == null || this.state.classes == null || !this.props.visible) {
            cssStyle = {display: 'none'};
        }

        const tPropClasses: Array<JSX.Element> = new Array();
        if (this.state.classes != null && this.state.properties != null) {
            let propClasses: Array<core.prop.PropertyClass> = this.state.classes;
            if (this.props.propClassFilter != null) {
                propClasses = propClasses.filter(this.props.propClassFilter);
            }
            if (this.state.selectedBasketIds.filter((basketId, index) => { return this.state.selectedBasketIds.indexOf(basketId) === index; }).length > 0) {
                tPropClasses.push(
                    <ArticlePropertyClass
                        articleItem={this.state.articleItem}
                        selectedBasketIdsCount={
                            this.state.selectedBasketIds.filter(
                                (basketId, index) => { return this.state.selectedBasketIds.indexOf(basketId) === index; }).length}
                        key={'info'}
                    />
                );
            }
            let keyCount: number = 0;
            for (const propClass of propClasses) {
                if (propClass != null) {
                    const properties: Array<core.prop.Property> | undefined = this.state.properties.get(propClass.key);
                    if (properties != null) {
                        keyCount++;
                        if (propClass.key === '') {
                            tPropClasses.push(
                                <PropertyClass
                                    key={'misc-' + keyCount.toString()}
                                    layoutType={this.props.layoutType}
                                    properties={properties}
                                    propertyClassName={t('Miscellaneous')}
                                    property={this.state.property}
                                    choiceList={this.state.choiceList}
                                />
                            );
                        } else {
                            tPropClasses.push(
                                <PropertyClass
                                    key={propClass.key}
                                    layoutType={this.props.layoutType}
                                    properties={properties}
                                    propertyClassName={propClass.name}
                                    property={this.state.property}
                                    choiceList={this.state.choiceList}
                                />
                            );
                        }
                    }
                }
            }
        }
        const articleInformations: JSX.Element = (
            <ArticleInformations
                articleItem={this.state.articleItem}
                selectedBasketIdsCount={this.state.selectedBasketIds.length}
                showPrices={this.props.showPrices}
            />
        );

        return (
            <div className="sidebar-tab-container" style={cssStyle} key={this.props.layoutType.toString()} id="property-editor">
                <div className="scrollbar-wcf" onScroll={this.onScroll}>
                    <SidebarHeader text={t('Properties')}/>
                    {articleInformations}
                    <div className={'sidebar-content' + (articleInformations == null ? ' standard-header' : ' property-list-content')}>
                        {tPropClasses.length ? tPropClasses : this.fallbackText()}
                    </div>
                </div>
            </div>
        );
    }

    protected onScroll: any = (event: React.SyntheticEvent): void => {
        const target: EventTarget = event.target;
        if (target == null) {
            return;
        }

        const jQueryElement: JQuery = jQuery(event.target);
        if (!jQueryElement) {
            return;
        }

        const scrollTop: number = jQueryElement.scrollTop();
        if (scrollTop == null) {
            return;
        }

        UIHelper.repositionFixedElements(
            scrollTop,
            (this.props.layoutType === LayoutType.DESKTOP ? 89 : 58),
            jQueryElement,
            [
                {class: '.property-article', toggleClass: 'fixed-in-sidebar'}
            ]
        );
    };

    protected getArticleProps = (basketIds: Array<string>): eaiws.basket.ArticleProperties | undefined => {
        const selectedArticles: Array<ArticleItem> = ArticleStore.getState().articleList.filter((articleItem: ArticleItem) => {
            return (
                articleItem.properties != null &&
                articleItem.properties.itemId != null &&
                basketIds.indexOf(articleItem.properties.itemId) !== -1
            );
        });
        if (selectedArticles.length === 1) {
            return selectedArticles[0].properties.article;
        }

        return;
    };

    protected onChange = (): void => {
        const tSetup: ArticleProperties = EAIWSStore.getState().propertyEditorSetup;
        this.setState(jQuery.extend(
            {},
            tSetup,
            EAIWSStore.getState().propertyEditorActive,
            {
                articleItem: EAIWSStore.getState().articleItem,
                // articleProperties: this.getArticleProps(SceneStore.getState().basketIds),
                selectedBasketIds: SceneStore.getState().basketIds,
                selectedElements: SceneStore.getState().selectedElements.length,
            }
        ));
    };

    protected fallbackText = (): JSX.Element => {
        if (this.state.selectedElements > 1) {
            return (
                <div className="no-properties-info">{t('The selected articles do not have any common properties.')}</div>
            );
        }
        return (
            <div className="no-properties-info">{t('The selected article does not have any properties.')}</div>
        );
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/propertyeditor/PropertyEditor.tsx